import React, {useEffect, useState} from 'react';
import {get} from '../../../api';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import {FormattedMessage} from 'react-intl';
import StatisticItem from '../cmp/StatisticItem';
import {connect} from "react-redux";
import LazyRangePicker from "../../cmp/flatpickr/LazyRangePicker";
import Big from 'big.js'
const opts = ['Visits', 'Orders', 'Conversions', 'Sales', 'Earnings'];

function AffiliateSalesSection({created, aff_summary_widget, aff_summary_default_dates}){
    const [data, setData] = useState(null);
    const [dates, setDates] = useState(aff_summary_default_dates || [
        new Date(created),
        new Date()
    ])
    useEffect(()=>{
        if(aff_summary_default_dates) {
            setDates(aff_summary_default_dates)
        }
    },[aff_summary_default_dates])
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        if(aff_summary_widget.length > 0) {
            const starttime = new Date(dates[0]).getTime();
            const endtime = new Date(dates[1]).getTime();
            setLoading(true)
            const abortController = new AbortController()
            Promise.all([
                get(`/mlm/stats/${starttime}/${endtime}`, null, abortController),
                get(`/sales/summary/${starttime}/${endtime}`, null, abortController)
            ]).then((d) => {
                const {amount, team_sales, target_bonus} = d[0];
                const {num_orders, referrals} = d[1];
                const conversion = referrals > 0 ? Big(num_orders || 0).div(referrals || 1).times(100).round(2) : 0;
                setData({
                    target_bonus,
                    mlm_amount: amount, team_sales,
                    ...d[1],
                    conversion: (conversion > 10 ? Math.round(conversion) : Big(conversion)) + "%"
                })
                setLoading(false)
            })
            return ()=>{
                abortController.abort()
            }
        }
    },[dates])
    if(aff_summary_widget.length === 0) return <div className={'my-4'}/>;
        return (
            <div className={'my-4'}>
                <div className={'row'}>
                    <div className={'col-sm-6 col-md-8'}>
                        <h3 className={'my-2'}><FormattedMessage id={'summary'}/></h3>
                    </div>
                    <div className={'col-sm-6 col-md-4'}>
                        <div className={'form-group'}>
                            <LazyRangePicker onChange={setDates} startDate={dates && dates[0]} endDate={dates && dates[1]}/>
                        </div>
                    </div>
                </div>
                <CardInfo {...data} loading={loading} aff_summary_widget={aff_summary_widget}/>
            </div>
        );
}


function CardInfo({aff_summary_widget, loading, referrals, num_orders, net_earnings, conversion, revenue, commission, team_sales, mlm_amount, target_bonus}) {
    const parts = {
        'Visits': <StatisticItem key={"visits"} value={referrals} id={'Referrals'} loading={loading}/>,
        'Orders': <StatisticItem key={"orders"} value={num_orders} id={'Orders'} loading={loading}/>,
        'Conversions': <StatisticItem key={"conversions"} value={conversion} id={'Conversions'} loading={loading}/>,
        'Sales': <StatisticItem key={"sales"} value={<CurrencyNumber value={revenue}/>} id={'Sales'}
                                loading={loading}/>,
        'Sale Earnings':<StatisticItem key={'sale_commission'}
                               value={<CurrencyNumber value={Number(commission || 0)}/>}
                               id={'Earnings'}
                               loading={loading}/>,
        'Earnings': <StatisticItem key={"earnings"}
                                   value={<CurrencyNumber value={Number(commission) + Number(mlm_amount)}/>}
                                   id={'Earnings'} loading={loading}/>,
        'Net Earnings':<StatisticItem key={"net_earnings"}
                                      value={<CurrencyNumber value={Number(net_earnings)}/>}
                                      id={'Net earnings'} loading={loading}/>,
        'Team sales': <StatisticItem key={'team_sales'}
                                     value={<CurrencyNumber value={Number(team_sales || 0)}/>}
                                     id={'Team sales'}
                                     loading={loading}/>,
        'Bonus':<StatisticItem key={'target_bonus'}
                               value={<CurrencyNumber value={Number(target_bonus || 0)}/>}
                               id={'Bonus'}
                               loading={loading}/>

    }


    return (<div className={'card-group'}>
        {
            aff_summary_widget.map((key) => {
                return parts[key]
            })
        }
    </div>);
}


function mapStateToProps(state) {
    return {
        aff_summary_widget: state.settings.aff_summary_widget ? JSON.parse(state.settings.aff_summary_widget) : opts,
        created: state.settings.created,
        aff_summary_default_dates: state.settings.aff_summary_default_dates,
    }
}


export default connect(mapStateToProps)(AffiliateSalesSection);
